import {
  getAdmin,
  setAdmin,
  removeLogo,
  toggleMfa,
  verifyMfaToken,
  getMfaStatus,
  getActiveSubscription,
  getStaffSummary,
  getStaffChartAnalysis,
  getStaffVerificationSummary,
  changePassword,
  getUserAgreementPDFUrlOrHtmlString,
  getFrontdeskFees,
  updateFrontdeskFees
} from "../../api.resource/api/root";
import { useToast } from "vue-toast-notification";

const $toast = useToast();

const state = {
  loading: false,
  removeLogoLoading: false,
  adminData: null,
  adminFirstName: null,
  toggleMfaSuccess: false,
  toggleMfaMsg: null,
  mfaTokenSuccess: false,
  mfaTokenMsg: null,
  mfaStatusValue: null,
  getAdminDataSuccess: false,
  getAdminDataMsg: null,
  mfaLoading: false,
  toggleMfaLoading: false,
  verifyMfaLoading: false,
  removeLogoSuccess: false,
  getActiveSubscriptionLoading: false,
  getActiveSubscriptionSuccess: false,
  activeSubscriptionData: null,
  getStaffSummaryLoading: false,
  getStaffSummarySuccess: false,
  staffSummary: false,
  totalGroup: null,
  totalStaff: null,
  medicalStaff: 0,
  nonMedicalStaff: 0,
  totalMonthlyMedicalStaff: 0,
  totalMonthlyNonMedicalStaff: 0,
  getStaffChartAnalysisLoading: false,
  getStaffChartAnalysisSuccess: false,
  staffChartAnalysis: null,
  staffStatusSummaryLoading: false,
  staffStatusSummarySuccess: false,
  staffStatusSummary: null,
  changePasswordLoading: false,
  secretKeyLoading: false,
  getUserAgreementContentLoading: false,
  getUserAgreementContentSuccess: false,
  userAgreementPDFUrl: null,
  userAgreementHTMLString: null,
  getFrontdeskFees: null,
  getFrontdeskFeesLoading: false,
  saveFrontdeskFeesLoading: false,
  getFrontdeskFeesError: null
};

const getters = {
  loading: state => state.loading,
  removeLogoLoading: state => state.removeLogoLoading,
  adminData: state => state.adminData,
  adminFirstName: state => state.adminFirstName,
  toggleMfaSuccess: state => state.toggleMfaSuccess,
  toggleMfaMsg: state => state.toggleMfaMsg,
  mfaTokenSuccess: state => state.mfaTokenSuccess,
  mfaTokenMsg: state => state.mfaTokenMsg,
  mfaStatusValue: state => state.mfaStatusValue,
  getAdminDataSuccess: state => state.getAdminDataSuccess,
  getAdminDataMsg: state => state.getAdminDataMsg,
  mfaLoading: state => state.mfaLoading,
  toggleMfaLoading: state => state.toggleMfaLoading,
  verifyMfaLoading: state => state.verifyMfaLoading,
  removeLogoSuccess: state => state.removeLogoSuccess,
  getActiveSubscriptionLoading: state => state.getActiveSubscriptionLoading,
  getActiveSubscriptionSuccess: state => state.getActiveSubscriptionSuccess,
  activeSubscriptionData: state => state.activeSubscriptionData,
  getStaffSummaryLoading: state => state.getStaffSummaryLoading,
  getStaffSummarySuccess: state => state.getStaffSummarySuccess,
  staffSummary: state => state.staffSummary,
  totalGroup: state => state.totalGroup,
  totalStaff: state => state.totalStaff,
  medicalStaff: state => state.medicalStaff,
  nonMedicalStaff: state => state.nonMedicalStaff,
  totalMonthlyMedicalStaff: state => state.totalMonthlyMedicalStaff,
  totalMonthlyNonMedicalStaff: state => state.totalMonthlyNonMedicalStaff,
  getStaffChartAnalysisLoading: state => state.getStaffChartAnalysisLoading,
  getStaffChartAnalysisSuccess: state => state.getStaffChartAnalysisSuccess,
  staffChartAnalysis: state => state.staffChartAnalysis,
  staffStatusSummaryLoading: state => state.staffStatusSummaryLoading,
  staffStatusSummarySuccess: state => state.staffStatusSummarySuccess,
  staffStatusSummary: state => state.staffStatusSummary,
  changePasswordLoading: state => state.changePasswordLoading,
  secretKeyLoading: state => state.secretKeyLoading,
  getUserAgreementContentLoading: state => state.getUserAgreementContentLoading,
  getUserAgreementContentSuccess: state => state.getUserAgreementContentSuccess,
  userAgreementPDFUrl: state => state.userAgreementPDFUrl,
  userAgreementHTMLString: state => state.userAgreementHTMLString,
  getFrontdeskFees: state => state.getFrontdeskFees,
  getFrontdeskFeesLoading: state => state.getFrontdeskFeesLoading,
  saveFrontdeskFeesLoading: state => state.saveFrontdeskFeesLoading,
  getFrontdeskFeesError: state => state.getFrontdeskFeesError
};

const actions = {
  async GET_ADMIN({ state, commit, rootState }) {
    commit("ADMIN_LOADING");
    let getAdminData = await getAdmin(rootState.auth.MCAdminCognitoID);

    if (getAdminData?.success) {
      commit("GET_ADMIN_SUCCESS", getAdminData?.result?.data);
      commit(
        "auth/RC_NUMBER",
        getAdminData?.result?.data?.MedicalCenterProfile?.mcContactInfo
          ?.rcNumber,
        { root: true }
      );
    } else {
      commit("GET_ADMIN_ERROR", getAdminData?.result?.data?.Description);
    }
    commit("ADMIN_LOADING_STOP");
  },
  // async SET_ADMIN({ commit }, payload) {
  //   // commit("ADMIN_LOADING");

  //   let setAdminData = await setAdmin(payload);

  //   if (setAdminData?.success === true) {
  //     commit("SET_ADMIN_SUCCESS", setAdminData?.message);
  //   }
  //   if (setAdminData?.success === false) {
  //     commit("SET_ADMIN_ERROR", setAdminData?.message);
  //   }
  // },

  async TOGGLE_MFA({ commit }, payload) {
    commit("RESET_TOGGLE_MFA");
    commit("TOGGLE_MFA_LOADING");

    let response = await toggleMfa(payload);

    if (response?.success) {
      commit("TOGGLE_MFA_SUCCESS", response?.result?.data?.Description);
    } else {
      commit("TOGGLE_MFA_ERROR", response?.result?.data?.Description);
    }

    commit("TOGGLE_MFA_LOADING_STOP");
  },
  async VERIFY_MFA_TOKEN({ commit }, payload) {
    commit("RESET_MFA_TOKEN");
    commit("VERIFY_MFA_LOADING");

    let response = await verifyMfaToken(payload);

    if (response?.success) {
      commit("MFA_TOKEN_SUCCESS", response?.message);
    } else {
      commit("MFA_TOKEN_ERROR", response?.result?.data?.Description);
    }

    commit("VERIFY_MFA_LOADING_STOP");
  },
  async MFA_STATUS({ commit }, payload) {
    commit("MFA_LOADING");
    let response = await getMfaStatus(payload);
    if (response?.success) {
      commit("MFA_STATUS_SUCCESS", response?.result?.data?.MFAStatus);
    } else {
      commit("MFA_STATUS_ERROR", response?.result?.data?.Description);
    }

    commit("MFA_LOADING_STOP");
  },
  async REMOVE_LOGO({ commit, rootState }, payload) {
    commit("REMOVE_LOGO_RESET");

    let response = await removeLogo(
      payload.profileTypeNumber,
      payload.fileName,
      rootState.auth.MCAdminCognitoID
    );

    if (response?.success) {
      commit("REMOVE_LOGO_SUCCESS", response?.message);
    } else {
      commit("REMOVE_LOGO_ERROR", response?.result?.data?.Description);
    }
  },
  async GET_ACTIVE_SUBSCRIPTION({ commit, rootState }) {
    commit("GET_ACTIVE_SUBSCRIPTION_LOADING");
    let response = await getActiveSubscription(rootState.auth.MCAdminCognitoID);

    if (response?.success) {
      commit("GET_ACTIVE_SUBSCRIPTION_SUCCESS", response?.result?.data);
    } else {
      commit("GET_ACTIVE_SUBSCRIPTION_ERROR");
    }
    commit("GET_ACTIVE_SUBSCRIPTION_STOP");
  },
  async GET_STAFF_SUMMARY({ commit, rootState }, payload) {
    commit("GET_STAFF_SUMMARY_LOADING");

    let response = await getStaffSummary(
      payload.timeLine,
      rootState.auth.MCAdminCognitoID
    );

    if (response?.success) {
      commit("GET_STAFF_SUMMARY_SUCCESS", response?.result.data);
      let staffAnalysis = response?.result?.data.staffAnalysis;
      if (response?.result?.data?.groupCount !== undefined) {
        commit("GET_GROUP_DATA", response?.result?.data?.groupCount);
      }
      if (staffAnalysis !== undefined) {
        commit("GET_STAFF_ANALYSIS_DATA", staffAnalysis);
        if (staffAnalysis.length <= 0) {
          commit("SET_STAFF_NULL_VALUE", staffAnalysis);
        } else if (staffAnalysis.length === 1) {
          if (staffAnalysis[0].type === "NonMedicalPractitioner") {
            commit("UNDEFINED_MEDICAL_BUT_DEFINED_NON_MEDICAL", staffAnalysis);
          } else if (staffAnalysis[0].type === "MedicalPractitoiner") {
            commit("UNDEFINED_NON_MEDICAL_BUT_DEFINED_MEDICAL", staffAnalysis);
          }
        } else if (staffAnalysis.length === 2) {
          for (const item of staffAnalysis) {
            if (item.type === "NonMedicalPractitioner") {
              commit("SET_NON_MEDICAL_STAFF_ANALYSIS", staffAnalysis);
            } else if (item.type === "MedicalPractitoiner") {
              commit("SET_MEDICAL_STAFF_ANALYSIS", staffAnalysis);
            }
          }
        }
      }
    } else {
      commit("GET_STAFF_SUMMARY_ERROR");
    }

    commit("GET_STAFF_SUMMARY_LOADING_STOP");
  },
  async GET_STAFF_CHART_ANALYSIS({ commit, rootState }, payload) {
    commit("GET_CHART_ANALYSIS_LOADING");

    let response = await getStaffChartAnalysis(
      payload.targetYear,
      payload.timeLine,
      rootState.auth.MCAdminCognitoID
    );

    if (response?.success) {
      if (response?.result?.data?.staffAnalysis.length > 0) {
        commit("GET_STAFF_CHART_ANALYSIS_SUCCESS", response?.result?.data);
      } else {
        commit("SET_STAFF_CHART_ANALYSIS_NULL_VALUE", response?.result?.data)
      }
    } else {
      commit("GET_STAFF_CHART_ANALYSIS_ERROR");
    }

    commit("GET_CHART_ANALYSIS_LOADING_STOP");
  },
  async GET_STAFF_VERIFICATION_SUMMARY({ commit, rootState }) {
    commit("STAFF_STATUS_SUMMARY_LOADING");

    let response = await getStaffVerificationSummary(
      rootState.auth.MCAdminCognitoID
    );

    if (response?.success) {
      commit("GET_STAFF_STATUS_SUMMARY_SUCCESS", response?.result?.data);
    } else {
      commit("GET_STAFF_STATUS_SUMMARY_ERROR");
    }

    commit("STAFF_STATUS_SUMMARY_LOADING_STOP");
  },
  async CHANGE_PASSWORD({ commit }, payload) {
    commit("CHANGE_PASSWORD_LOADING");

    let response = await changePassword(payload);

    if (response?.success) {
      commit("CHANGE_PASSWORD_SUCCESS", response?.result?.data?.Description);
    } else {
      commit("CHANGE_PASSWORD_ERROR", response?.result?.data?.Description);
    }

    commit("CHANGE_PASSWORD_LOADING_STOP");
  },
  async USER_AGREEMENT_PDF({ commit }, payload) {
    commit("USER_AGREEMENT_CONTENT_LOADING");

    let response = await getUserAgreementPDFUrlOrHtmlString(payload);

    if (response?.success) {
      commit("USER_AGREEMENT_PDF_URL_SUCCESS", response?.result?.data);
    } else {
      commit("USER_AGREEMENT_CONTENT_ERROR", response?.result?.data);
    }

    commit("USER_AGREEMENT_CONTENT_LOADING_STOP");
  },
  async USER_AGREEMENT_HTML_STRING({ commit, dispatch }, payload) {
    commit("USER_AGREEMENT_CONTENT_LOADING");

    let response = await getUserAgreementPDFUrlOrHtmlString(payload);

    if (response?.success && response?.status) {
      commit("USER_AGREEMENT_HTML_STRING_SUCCESS", response?.result?.data);
      dispatch("USER_AGREEMENT_PDF", "PDF");
    } else {
      commit("USER_AGREEMENT_CONTENT_ERROR", response?.result?.data);
    }

    commit("USER_AGREEMENT_CONTENT_LOADING_STOP");
  },
  async GET_FRONTDESK_FEES({ commit, rootState }) {
    const tenantId = rootState.auth.MCAdminCognitoID;
    if (!tenantId) return;

    try {
      commit("GET_FRONTDESK_FEES_LOADING", true);

      const response = await getFrontdeskFees(tenantId);
      const data = response?.result?.data;

      if (
        response?.success &&
        data?.registrationFeeAmount !== undefined &&
        data?.visitFeeAmount !== undefined
      ) {
        commit("GET_FRONTDESK_FEES_SUCCESS", {
          registrationFee: Number(data.registrationFeeAmount),
          visitFee: Number(data.visitFeeAmount)
        });
      } else {
        commit(
          "GET_FRONTDESK_FEES_ERROR",
          response?.result?.data?.Description ?? response?.message
        );
      }
    } catch (error) {
      console.error("Error fetching frontdesk fees:", error);
      commit("GET_FRONTDESK_FEES_ERROR", "Error retrieving frontdesk fees.");
    } finally {
      commit("GET_FRONTDESK_FEES_LOADING", false);
    }
  },
  async SAVE_FRONTDESK_FEES({ commit, dispatch, rootState, state }, payload) {
    if (state.saveFrontdeskFeesLoading) return;

    try {
      commit("SAVE_FRONTDESK_FEES_LOADING", true);

      const response = await updateFrontdeskFees(rootState.auth.MCAdminCognitoID, {
        registrationFeeAmount: payload.registrationFee,
        visitFeeAmount: payload.visitFee
      });

      if (response?.success) {
        commit(
          "SAVE_FRONTDESK_FEES_SUCCESS",
          response?.result?.data?.Description ?? response?.message
        );
        await dispatch("GET_FRONTDESK_FEES");
      } else {
        commit(
          "SAVE_FRONTDESK_FEES_ERROR",
          response?.result?.data?.Description ?? response?.message
        );
      }
    } catch (error) {
      console.error("Error saving frontdesk fees:", error);
      commit("SAVE_FRONTDESK_FEES_ERROR", "Failed to save frontdesk fees.");
    } finally {
      commit("SAVE_FRONTDESK_FEES_LOADING", false);
    }
  }
};

const mutations = {
  ADMIN_LOADING(state) {
    state.loading = true;
  },
  ADMIN_LOADING_STOP(state) {
    state.loading = false;
  },
  MFA_LOADING(state) {
    state.mfaLoading = true;
  },
  MFA_LOADING_STOP(state) {
    state.mfaLoading = false;
  },
  TOGGLE_MFA_LOADING(state) {
    state.toggleMfaLoading = true;
  },
  TOGGLE_MFA_LOADING_STOP(state) {
    state.toggleMfaLoading = false;
  },
  VERIFY_MFA_LOADING(state) {
    state.verifyMfaLoading = true;
  },
  VERIFY_MFA_LOADING_STOP(state) {
    state.verifyMfaLoading = false;
  },
  SECRETKEY_LOADING(state) {
    state.secretKeyLoading = true;
  },
  SECRETKEY_LOADING_STOP(state) {
    state.secretKeyLoading = false;
  },
  GET_ACTIVE_SUBSCRIPTION_LOADING(state) {
    state.getActiveSubscriptionLoading = true;
  },
  GET_ACTIVE_SUBSCRIPTION_STOP(state) {
    state.getActiveSubscriptionLoading = false;
  },
  GET_STAFF_SUMMARY_LOADING(state) {
    state.getStaffSummaryLoading = true;
  },
  GET_STAFF_SUMMARY_LOADING_STOP(state) {
    state.getStaffSummaryLoading = false;
  },
  STAFF_STATUS_SUMMARY_LOADING(state) {
    state.staffStatusSummaryLoading = true;
  },
  STAFF_STATUS_SUMMARY_LOADING_STOP(state) {
    state.staffStatusSummaryLoading = false;
  },
  GET_ADMIN_SUCCESS(state, payload) {
    state.loading = false;
    state.adminData = payload;
    state.adminFirstName = payload.AdminProfile.firstName;
    state.getAdminDataMsg = payload.Description;
    state.getAdminDataSuccess = true;
  },
  GET_ADMIN_ERROR(state, payload) {
    state.loading = false;
    state.adminData = null;
    state.adminFirstName = null;
    state.getAdminDataMsg = payload;
    state.getAdminDataSuccess = false;
  },
  SET_ADMIN_ERROR(state, payload) {
    state.loading = false;
    $toast.error(payload, { position: "top-right" });
  },
  TOGGLE_MFA_SUCCESS(state, payload) {
    state.loading = false;
    state.toggleMfaSuccess = true;
    state.toggleMfaMsg = payload;
  },
  TOGGLE_MFA_ERROR(state, payload) {
    state.loading = false;
    state.toggleMfaSuccess = false;
    state.toggleMfaMsg = payload;
  },
  RESET_TOGGLE_MFA(state) {
    state.loading = false;
    state.toggleMfaSuccess = false;
    state.toggleMfaMsg = null;
  },
  MFA_TOKEN_SUCCESS(state, payload) {
    state.loading = false;
    state.mfaTokenSuccess = true;
    state.mfaTokenMsg = payload;
  },
  MFA_TOKEN_ERROR(state, payload) {
    state.loading = false;
    state.mfaTokenSuccess = false;
    state.mfaTokenMsg = payload;
  },
  RESET_MFA_TOKEN(state, payload) {
    state.loading = false;
    state.mfaTokenSuccess = false;
    state.mfaTokenMsg = null;
  },
  MFA_STATUS_SUCCESS(state, payload) {
    state.mfaStatusValue = payload;
  },
  MFA_STATUS_ERROR(state, payload) {
    state.mfaStatusValue = payload;
  },
  RESET_ADMIN_DATA(state) {
    state.loading = false;
    state.adminData = null;
    state.getAdminDataMsg = null;
    state.getAdminDataSuccess = false;
  },
  REMOVE_LOGO_LOADING(state) {
    state.removeLogoLoading = true;
  },
  REMOVE_LOGO_LOADING_STOP(state) {
    state.removeLogoLoading = false;
  },
  REMOVE_LOGO_SUCCESS(state, payload) {
    state.removeLogoLoading = false;
    $toast.success(payload, { position: "top-right" });
    state.removeLogoSuccess = true;
  },
  REMOVE_LOGO_ERROR(state, payload) {
    state.removeLogoLoading = false
    $toast.error(payload, { position: "top-right" });
    state.removeLogoSuccess = false;
  },
  REMOVE_LOGO_RESET(state) {
    state.removeLogoSuccess = false;
  },
  GET_ACTIVE_SUBSCRIPTION_SUCCESS(state, payload) {
    state.getActiveSubscriptionLoading = false;
    state.getActiveSubscriptionSuccess = true;
    state.activeSubscriptionData = payload?.activeSubscription;
  },
  GET_ACTIVE_SUBSCRIPTION_ERROR(state, payload) {
    state.getActiveSubscriptionLoading = false;
    state.getActiveSubscriptionSuccess = false;
    state.activeSubscriptionData = null;
  },
  GET_STAFF_SUMMARY_SUCCESS(state, payload) {
    state.getStaffSummaryLoading = false;
    state.getStaffSummarySuccess = true;
  },
  GET_STAFF_ANALYSIS_DATA(state, payload) {
    state.totalStaff = payload;
  },
  SET_MEDICAL_STAFF_ANALYSIS(state, payload) {
    state.medicalStaff = payload[0].count;
    state.totalMonthlyMedicalStaff = payload[0].context.count;
  },
  SET_NON_MEDICAL_STAFF_ANALYSIS(state, payload) {
    state.nonMedicalStaff = payload[1].count;
    state.totalMonthlyNonMedicalStaff = payload[1].context.count;
  },
  UNDEFINED_MEDICAL_BUT_DEFINED_NON_MEDICAL(state, payload) {
    state.nonMedicalStaff = payload[0].count;
    state.totalMonthlyNonMedicalStaff = payload[0].context.count;
    state.medicalStaff = 0;
    state.totalMonthlyMedicalStaff = 0;
  },
  UNDEFINED_NON_MEDICAL_BUT_DEFINED_MEDICAL(state, payload) {
    state.medicalStaff = payload[0].count;
    state.totalMonthlyMedicalStaff = payload[0].context.count;
    state.nonMedicalStaff = 0;
    state.totalMonthlyNonMedicalStaff = 0;
  },
  SET_STAFF_NULL_VALUE(state) {
    state.nonMedicalStaff = 0
    state.medicalStaff = 0
  },
  GET_GROUP_DATA(state, payload) {
    state.totalGroup = payload?.count;
  },
  GET_STAFF_SUMMARY_ERROR(state) {
    state.getStaffSummaryLoading = false;
    state.getStaffSummarySuccess = false;
    state.totalGroup = null;
  },
  RESET_CHART_ANALYSIS(state) {
    state.getStaffChartAnalysisLoading = false;
    state.getStaffChartAnalysisSuccess = false;
    state.staffChartAnalysis = null;
  },
  GET_CHART_ANALYSIS_LOADING(state) {
    state.getStaffChartAnalysisLoading = true;
  },
  GET_CHART_ANALYSIS_LOADING_STOP(state) {
    state.getStaffChartAnalysisLoading = false;
  },
  GET_STAFF_CHART_ANALYSIS_SUCCESS(state, payload) {
    state.getStaffChartAnalysisLoading = false;
    state.getStaffChartAnalysisSuccess = true;
    state.staffChartAnalysis = payload?.staffAnalysis;
  },
  GET_STAFF_CHART_ANALYSIS_ERROR(state) {
    state.getStaffChartAnalysisLoading = false;
    state.getStaffChartAnalysisSuccess = false;
    state.staffChartAnalysis = null;
  },
  SET_STAFF_CHART_ANALYSIS_NULL_VALUE(state) {
    state.staffChartAnalysis = null;
  },
  GET_STAFF_STATUS_SUMMARY_SUCCESS(state, payload) {
    state.staffStatusSummaryLoading = false;
    state.staffStatusSummarySuccess = true;
    state.staffStatusSummary = payload;
  },
  GET_STAFF_STATUS_SUMMARY_ERROR(state, payload) {
    state.staffStatusSummaryLoading = false;
    state.staffStatusSummarySuccess = false;
    // state.staffStatusSummary = payload
  },
  CHANGE_PASSWORD_LOADING(state) {
    state.changePasswordLoading = true;
  },
  CHANGE_PASSWORD_LOADING_STOP(state) {
    state.changePasswordLoading = false;
  },
  CHANGE_PASSWORD_SUCCESS(state, payload) {
    state.changePasswordLoading = false;
    $toast.success(payload, { position: "top-right" });
  },
  CHANGE_PASSWORD_ERROR(state, payload) {
    state.changePasswordLoading = false;
    $toast.error(payload, { position: "top-right" });
  },
  // SET_ADMIN_SUCCESS(state, payload) {
  //   state.loading = false;
  //   $toast.success(payload, { position: "top-right" });
  // },
  // SET_ADMIN_ERROR(state, payload) {
  //   state.loading = false;
  //   $toast.error(payload, { position: "top-right" });
  // }
  USER_AGREEMENT_CONTENT_LOADING(state, payload) {
    state.getUserAgreementContentLoading = false;
  },
  USER_AGREEMENT_CONTENT_LOADING_STOP(state, payload) {
    state.getUserAgreementContentLoading = false;
  },
  USER_AGREEMENT_PDF_URL_SUCCESS(state, payload) {
    state.getUserAgreementContentLoading = false;
    state.getUserAgreementContentSuccess = true;
    state.userAgreementPDFUrl = payload?.UserAgreement;
  },
  USER_AGREEMENT_HTML_STRING_SUCCESS(state, payload) {
    state.getUserAgreementContentLoading = false;
    state.getUserAgreementContentSuccess = true;
    state.userAgreementHTMLString = payload?.UserAgreement;
  },
  USER_AGREEMENT_CONTENT_ERROR(state, payload) {
    state.getUserAgreementContentLoading = false;
    state.getUserAgreementContentSuccess = false;
  },
  GET_FRONTDESK_FEES_LOADING(state, payload) {
		state.getFrontdeskFeesLoading = payload;
	},
  RESET_FRONTDESK_FEES(state) {
    state.getFrontdeskFeesError = null;
  },
  GET_FRONTDESK_FEES_SUCCESS(state, payload) {
    state.getFrontdeskFees = payload;
    state.getFrontdeskFeesError = null;
  },
  GET_FRONTDESK_FEES_ERROR(state, payload) {
    state.getFrontdeskFees = null;
    state.getFrontdeskFeesError = payload;
    $toast.error(payload, { position: "top-right" });
  },
  SAVE_FRONTDESK_FEES_LOADING(state, payload) {
    state.saveFrontdeskFeesLoading = payload;
  },
  SAVE_FRONTDESK_FEES_SUCCESS(state, payload) {
    state.getFrontdeskFeesError = null;
    $toast.success(
      payload || "Frontdesk fees saved successfully",
      { position: "top-right" }
    );
  },
  SAVE_FRONTDESK_FEES_ERROR(state, payload) {
    state.getFrontdeskFeesError = payload;
    $toast.error(payload, { position: "top-right" });
  }
};

export default {
  namespaced: true,
  state: () => ({ ...state }),
  getters,
  actions,
  mutations
};
